import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SlideFrame } from '../SlideFrame';
import { portfolioRows, portfolioMethod } from '../../data/deckContent';
const COLUMNS = ['Product', 'HCP problem', 'Solventum difference', 'Reward'];
export function PortfolioSlide() {
  const reduced = useReducedMotion();
  return <SlideFrame eyebrow="The portfolio" index={8} chapter="tactics" data-id="element-118" data-mp="2qev5l9m4wq7e">
      <div data-id="element-119" data-mp="354j4y5ar9esh">
        <h2 className="max-w-[34ch] text-[clamp(20px,2.8vw,50px)] font-semibold leading-[1.06] tracking-tight text-white" data-id="element-120" data-mp="35410ildxvu9h">
          Where does Solventum have something worth 30 seconds?
        </h2>

        <div className="mt-[1.6vh] flex flex-wrap items-baseline gap-x-[1.4vw] gap-y-[0.6vh]" data-id="element-121" data-mp="3e4pg3kize2oh">
          <p className="text-[clamp(10px,0.95vw,18px)] font-light text-white/40" data-id="element-122" data-mp="3a5qdi6kq2i07">
            We should not start with “What content do we have?”
          </p>
          <p className="text-[clamp(12px,1.4vw,27px)] font-medium text-[color:var(--sv-green)]" data-id="element-123" data-mp="1fqnr4hqyzg1i">
            Start with: “What can we genuinely give back?”
          </p>
        </div>

        <div className="mt-[3vh]" data-id="element-124" data-mp="16nlhgqbjrny7">
          <div className="grid grid-cols-[1.1fr_1.5fr_1.7fr_0.8fr] gap-x-[1.4vw] border-b border-white/12 pb-[1vh]" data-id="element-125" data-mp="1bnre6kwoc0n5">
            {COLUMNS.map(column => <span key={column} className="text-[clamp(8px,0.78vw,14px)] font-medium uppercase tracking-[0.26em] text-white/40" data-id="element-126" data-mp="1glsvp1egbrwi">
                {column}
              </span>)}
          </div>

          {portfolioRows.map((row, i) => <motion.div key={row.product} initial={reduced ? false : {
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.05 * i,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid grid-cols-[1.1fr_1.5fr_1.7fr_0.8fr] items-center gap-x-[1.4vw] border-b border-white/[0.07] py-[1.5vh]" data-id="element-127" data-mp="1ugv909lmojjc" data-mpi={i}>
              <span className="text-[clamp(11px,1.15vw,22px)] font-medium text-white" data-id="element-128" data-mp="1z9730kr09xb">
                {row.product}
              </span>
              <span className={`text-[clamp(9px,0.95vw,18px)] font-light leading-snug ${row.defined ? 'text-white/60' : 'text-white/25'}`} data-id="element-129" data-mp="3u4mugkblwjjr">
                {row.problem}
              </span>
              <span className={`text-[clamp(9px,0.95vw,18px)] font-light leading-snug ${row.defined ? 'text-white/60' : 'text-white/25'}`} data-id="element-130" data-mp="kw0wlrqvvl9t">
                {row.difference}
              </span>
              <span className={`text-[clamp(9px,0.85vw,16px)] font-semibold uppercase tracking-[0.22em] ${row.defined ? 'text-[color:var(--sv-green)]' : 'text-white/25'}`} data-id="element-131" data-mp="pobz92d0dl62">
                {row.reward}
              </span>
            </motion.div>)}
        </div>

        <div className="mt-[3vh] flex items-center gap-[0.9vw]" data-id="element-132" data-mp="1j66yxajod2xv">
          <span className="text-[clamp(8px,0.72vw,13px)] uppercase tracking-[0.3em] text-white/30" data-id="element-133" data-mp="1n93esthtyky4">
            Method
          </span>
          {portfolioMethod.map((step, i) => <span key={step} className="flex items-center gap-[0.9vw] text-[clamp(10px,1.05vw,20px)] font-light text-white/75" data-id="element-134" data-mp="1e7nejekqbz7m" data-mpi={i}>
              {step}
              {i < portfolioMethod.length - 1 ? <span aria-hidden="true" className="text-[color:var(--sv-green)]/70" data-id="element-135" data-mp="14clrcoa0l77o">
                  →
                </span> : null}
            </span>)}
        </div>
      </div>
    </SlideFrame>;
}